import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';
import useTranslations from '../../hooks/useTranslations';
import Button from '../Button';

interface IModalScrappageDeal {
    onSubmit: (isWithScrappage: boolean) => void;
}

export const ModalScrappage: React.FC<IModalScrappageDeal> = ({ onSubmit }) => {
    const { t } = useTranslations();

    return (
        <Wrapper>
            <Title>{t('dialog.scrappage.title')}</Title>
            <Description>{t('dialog.scrappage.description')}</Description>
            <Agreement>{t('dialog.scrappage.agreement')}</Agreement>
            <ButtonWrapper>
                <Button onClick={() => onSubmit(false)}>{t('dialog.scrappage.withoutScrappage')}</Button>
                <Button onClick={() => onSubmit(true)} primary>
                    {t('dialog.scrappage.withScrappage')}
                </Button>
            </ButtonWrapper>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    width: 100%;
`;
const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;

    button {
        width: 40%;
    }
`;
const Title = styled.p`
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.black1};
    font-size: ${rem('22px')};
`;
const Agreement = styled.p`
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.black1};
    font-size: ${rem('18px')};
    padding-bottom: ${rem(15)};
`;
const Description = styled.p`
    padding: ${rem(15)} 0;
`;
